import React from 'react'
import {ArrowDownUp, CaretDownFill, CaretUpFill} from 'react-bootstrap-icons'
import {KTSVG} from '../../../../../_metronic/helpers'
import {ContactTableHeaderProps, TableColumn} from './types'
import {
  FIELD_ACTION,
  FIELD_LAST_UPDATED,
  FIELD_FLOW,
  FIELD_NOTES,
  FIELD_PROMO_ACTION,
  FIELD_SELECTED,
  FIELD_TAGS,
  SORT_ASC,
  FIELD_ASSIGN_TO,
  FIELD_STATUS,
  FIELD_OUTBOUND_MESSAGE,
  FIELD_REPLIES,
  FIELD_LAST_MESSAGE_PREVIEW,
  FIELD_SALES,
  FIELD_STATUS_SUBSCRIBE,
  FIELD_UNSUBSCRIBED_AT,
} from '../constants'

const FIXED_COLUMNS = [FIELD_SELECTED, FIELD_ACTION]

export const ContactTableHeader: React.FC<ContactTableHeaderProps> = ({
  columns,
  sortKey,
  sortDirection,
  onSort,
  isLoading,
  selectedAll,
  onSelectAll,
  hasSelectableContacts = true,
  onColumnReorder,
}) => {
  const isSortable = (key: string) => {
    return (
      key !== FIELD_SELECTED &&
      key !== FIELD_TAGS &&
      key !== FIELD_NOTES &&
      key !== FIELD_ACTION &&
      key !== FIELD_PROMO_ACTION &&
      key !== FIELD_FLOW &&
      key !== FIELD_LAST_UPDATED &&
      key !== FIELD_ASSIGN_TO &&
      key !== FIELD_STATUS &&
      key !== FIELD_OUTBOUND_MESSAGE &&
      key !== FIELD_REPLIES &&
      key !== FIELD_LAST_MESSAGE_PREVIEW &&
      key !== FIELD_SALES &&
      key !== FIELD_STATUS_SUBSCRIBE &&
      key !== FIELD_UNSUBSCRIBED_AT
    )
  }
  // Sort icon renderer
  const renderSortIcon = (key: string) => {
    if (!isSortable(key)) {
      return null
    }

    if (sortKey !== key) {
      return <ArrowDownUp className='sort-icon ms-2' size={12} />
    }
    return sortDirection === SORT_ASC ? (
      <CaretUpFill className='sort-icon ms-2' size={12} />
    ) : (
      <CaretDownFill className='sort-icon ms-2' size={12} />
    )
  }

  // Render checkbox for the select all column
  const renderSelectAllCheckbox = (column: TableColumn) => {
    if (column.key === FIELD_SELECTED) {
      return (
        <div className='form-check form-check-sm form-check-custom'>
          <input
            className='form-check-input'
            type='checkbox'
            checked={selectedAll}
            onChange={onSelectAll}
            disabled={isLoading || !hasSelectableContacts}
          />
        </div>
      )
    }
    return column.title
  }

  return (
    <thead>
      <tr className='border-bottom'>
        {columns.map((column: TableColumn, index: number) => (
          <th
            key={column.key}
            draggable={onColumnReorder && !FIXED_COLUMNS.includes(column.key) ? true : false}
            onDragStart={(e) => {
              if (FIXED_COLUMNS.includes(column.key)) return
              e.dataTransfer.setData('text/plain', index.toString())
            }}
            onDragOver={(e) => {
              if (!onColumnReorder) return
              if (FIXED_COLUMNS.includes(column.key)) return // cannot drop on fixed column
              e.preventDefault()
            }}
            onDrop={(e) => {
              if (!onColumnReorder) return
              if (FIXED_COLUMNS.includes(column.key)) return
              const sourceIndex = Number(e.dataTransfer.getData('text/plain'))
              const sourceKey = columns[sourceIndex]?.key
              if (FIXED_COLUMNS.includes(sourceKey)) return // can't drag fixed
              if (sourceIndex !== index) {
                onColumnReorder(sourceIndex, index)
              }
            }}
            className={`text-muted sortable column-${column.key} ${
              column.width ? `min-w-${column.width}` : ''
            } ${isLoading ? 'disabled' : ''} ${column.key === FIELD_SELECTED ? 'table-header-default-cursor bg-white' : ''}`}
            onClick={() => (isSortable(column.key) ? onSort(column.key) : null)}
          >
            <div className={`d-flex align-items-center ${column?.className || ''}`}>
              {column.key === FIELD_SELECTED ? (
                renderSelectAllCheckbox(column)
              ) : (
                <>
                  {column.iconPath && (
                    <KTSVG path={column.iconPath} className='svg-icon-2 me-1 text-muted' />
                  )}
                  {column.title}
                </>
              )}
              {renderSortIcon(column.key)}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  )
}
